import { IEnrolModel } from 'models/enrol.model'
import api from '..'

const updateEnrol = (enrol: IEnrolModel) => {
  const { id, note, answerAdmin, stateAdmin, courseId, userId } = enrol
  return api.put(`enrols/${id}`, {
    enrol: {
      note,
      answerAdmin,
      stateAdmin,
      courseId,
      userId,
    },
  })
}

export default updateEnrol
